import type { ReactNode } from 'react'

export function RenderEvenlySpaced({ text, value }: { text: string | number | ReactNode; value: string | number | ReactNode }) {
  return (
    <div className="p-2 flex flex-row items-center">
      <span className="inline-block flex-1"> {text}</span>
      <span className="inline-block flex-1">{value}</span>
    </div>
  )
}
